import { useNavigate } from 'react-router-dom';
import { removeCarInfo, removeCarSelected } from 'store/reducers/carSelectedSlices';
import { login } from 'store/reducers/useSlices';
import { useAppDispatch } from './redux';
import { setLoadingPriceCheckedStatus } from 'store/slices/buttonPriceCheckedStatus.slice';
import { removeCartSlice } from 'store/slices/cart-v2.slice';
import { removeInfoManufacturerSupplier } from 'store/reducers/manufacturer-supplier';

const useLogOut = (): (() => void) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  return () => {
    localStorage.clear();
    dispatch(login(null));
    dispatch(removeCarInfo());
    dispatch(removeCarSelected());
    dispatch(setLoadingPriceCheckedStatus(false));
    dispatch(removeCartSlice());
    dispatch(removeInfoManufacturerSupplier());
    navigate('/login');
  };
};

export default useLogOut;
